import React, { forwardRef } from "react";

const Section = forwardRef((props, ref) => {
  return (
    <div
      id={props.id}
      ref={ref}
      data-section={props.id}
      className={[
        "snap-always snap-center container max-w-[1280px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16 py-32 px-8 lg:px-4",
        props.borderTopBottom
          ? "border border-t-slate-300 border-b-slate-300 border-r-0 border-l-0"
          : "",
      ].join(" ")}
    >
      {props.children}
    </div>
  );
});

export default Section;
